const user = (state = {}, action) => {
  switch (action.type) {
    case "ADD_ITEMS":
      return { ...state, ...action.payload };
    case "REMOVE_ITEMS":
      return {};
    default:
      return state;
  }
};
export default user;
